import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Card, Button, Form, Spinner, Container } from 'react-bootstrap';
import { api } from '../../services/api.js';

function AvaliacaoDependenteToken() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");

    const [detalhes, setDetalhes] = useState(null);
    const [loading, setLoading] = useState(true);
    const [motivo, setMotivo] = useState("");
    const [concluido, setConcluido] = useState(false);

    useEffect(() => {
        if (token) {
            api.get(`/rh/comunicacao/dependente/detalhes-token/${token}`)
                .then(res => setDetalhes(res.data))
                .catch(err => alert("Link inválido ou expirado."))
                .finally(() => setLoading(false));
        }
    }, [token]);

    const handleAcao = (aprovadoValue) => {
        setLoading(true);
        api.post('/rh/comunicacao/dependente/avaliar-token', {
            token,
            aprovado: aprovadoValue, // 1 = Aprovado, 2 = Negado
            observacao: motivo
        })
        .then(() => setConcluido(true))
        .catch(err => alert("Erro ao registrar avaliação: " + err.message))
        .finally(() => setLoading(false));
    };

    if (loading) {
        return (
            <Container className="text-center my-5 py-5">
                <Spinner animation="border" style={{ color: '#991b1b' }} />
                <div className="mt-2 fw-bold text-muted">Carregando detalhes...</div>
            </Container>
        );
    }

    if (concluido) {
        return (
            <Container className="my-5" style={{ maxWidth: '600px' }}>
                <Card className="p-4 shadow-sm text-center border-0">
                    <h4 className="fw-bold" style={{ color: '#991b1b' }}>Avaliação Registrada com Sucesso!</h4>
                    <p className="text-muted mb-0">Sua resposta foi gravada com segurança no sistema.</p>
                </Card>
            </Container>
        );
    }

    return (
        <Container className="my-5" style={{ maxWidth: '600px' }}>
            <Card className="shadow-sm border-0 rounded-3 overflow-hidden">
                <Card.Header className="text-white text-center fw-bold py-3" style={{ backgroundColor: '#991b1b', fontSize: '1.1rem' }}>
                    Avaliação de Comunicado de RH
                </Card.Header>
                <Card.Body className="p-4">
                    {detalhes && (
                        <div>
                            <div className="bg-light p-3 rounded mb-3 border">
                                <p className="mb-1"><strong>Colaborador:</strong> {detalhes.nome} ({detalhes.chapa})</p>
                                <p className="mb-1"><strong>Operação:</strong> {detalhes.tipo}</p>
                                <p className="mb-0"><strong>Data Efetiva:</strong> {detalhes.dataefetivo}</p>
                            </div>

                            <Form.Group className="mb-4">
                                <Form.Label className="fw-bold small text-dark">Observações / Parecer:</Form.Label>
                                <Form.Control 
                                    as="textarea" 
                                    rows={3} 
                                    value={motivo} 
                                    onChange={e => setMotivo(e.target.value)} 
                                    placeholder="Digite suas observações..." 
                                />
                            </Form.Group>

                            <div className="d-flex justify-content-between gap-2">
                                <Button variant="danger" className="w-50 fw-bold py-2" onClick={() => handleAcao(2)} disabled={!motivo}>
                                    NEGAR
                                </Button>
                                <Button variant="success" className="w-50 fw-bold py-2" onClick={() => handleAcao(1)}>
                                    APROVAR
                                </Button>
                            </div>
                        </div>
                    )}
                </Card.Body>
            </Card>
        </Container>
    );
}

export default AvaliacaoDependenteToken;